<!--
트래킹검수 > 스캔 컴포넌트
------------------------------------
-->
<template>
    <div class="uk-height-1-1 uk-flex uk-flex-column" @click="focus">
        <div class="uk-margin-auto-vertical uk-text-center">





            <!-- 입력검증 메세지 -->
            <div class="uk-text-large3 uk-text-danger" v-show="isEmptyScan">
                입력된 값이 없습니다
            </div>

            <!-- 이미 입고처리된 BOX 메세지 -->
            <div class="uk-text-large3 uk-text-danger" v-show="isAlreadyShipIn">
                이미 입고처리된 BOX 입니다<br />
                {{ diffCreatedAt }}
            </div>

            <!-- 입고결과 안내 -->
            <div class="result" :class="resultClass" v-show="scan">


                <div class="uk-flex uk-flex-bottom">
                    <div class="center" :class="center.transport" v-if="center">
                        <i class="material-icons">{{ center.transport_material_icon }}</i>
                        {{ center.transport_text }}
                    </div>

                    <div class="title uk-width-expand">
                        {{ classficationText }}
                    </div>
                </div>


                <div class="move-to">
                    {{ classficationGuide }}
                </div>

                <div class="print" v-show="printable">
                    <button
                        type="button"
                        class="uk-button uk-button-dg-w-dg uk-button-on-dg-w-dg uk-button-large2"
                        @click="$parent.printShipInLabel(scan.id)"
                    >
                        <i class="material-icons">print</i>
                        <span class="text">PRINT</span>
                    </button>
                </div>

            </div>

            <!-- 스캔 모듈 -->
            <div class="scan-input" :class="scanInputClass">
                <div class="title">
                    <i class="material-icons">
                        aspect_ratio
                    </i>
                    입고 BOX를 스캔하세요

                    <!-- 트래킹정보 DB 갱신 -->
                    <refresh-tracking-db
                        :csrf-token="csrfToken"
                        :region-id="regionId"
                        @refreshed="refreshedTrackingDb = true"

                        ref="refresh"
                    ></refresh-tracking-db>
                </div>





                <div>
                    <!-- 트래킹DB 로딩전에는 스캔입력 금지 -->
                    <input
                        :disabled="! refreshedTrackingDb"
                        type="text"
                        ref="scan"
                        placeholder="SCAN, HERE"
                        autofocus
                        @keyup.enter="scanning"
                    />
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import regionAble from "../../common/region-able.vue";

    export default {
        mixins: [
            regionAble,
        ],
        components: {
            'refresh-tracking-db': require('./refresh-tracking-db.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,

            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 현재 스캔된 정보
             */
            scan: {
                type: Object,
                default: null,
            },



        },
        data: function () {
            return {
                // (bool) 빈값을 엔터쳤을때 경고문구 출력여부
                isEmptyScan: false,

                // (bool) 트래킹DB 로드 여부
                refreshedTrackingDb: false,

            };
        },
        computed: {

            /**
             * 입고센터
             * - 일본 항공2센터/해상2센터 커스텀에서 사용
             * @return object
             */
            center() {
                let custom_region_ids = [9, 10];
                if (! custom_region_ids.includes(this.regionId)) {
                    return null;
                }

                if (! this.scan) {
                    return null;
                }
                return this.get_region(this.scan.region_id);
            },

            /**
             * 분류결과
             **/
            classficationText() {
                if (! this.scan) {
                    return null;
                }

                if (this.scan.urgent_type === 1) {
                    return 'URGENT (' + this.scan.urgent_type_text + ')';
                } else if (this.scan.classification === 1) {
                    return 'NORMAL (' + this.scan.classification_text + ')';
                } else if (this.scan.classification === 2) {
                    return 'MULTI MATCH (' + this.scan.classification_text + ')';
                } else if (this.scan.classification === 3) {
                    return 'NO DATA (' + this.scan.classification_text + ')';
                } else if (this.scan.classification === 4) {
                    return this.scan.classification_text;
                } else if (this.scan.classification === 5) {
                    return 'MULTI TRACKING (' + this.scan.classification_text + ')';
                } else if (this.scan.classification === 91) {
                    return 'RETURN (' + this.scan.classification_text + ')';
                }
            },

            /**
             * 분류안내
             **/
            classficationGuide() {
                if (! this.scan) {
                    return null;
                }
                let guide = 'Print and Move box to ';

                if (this.scan.urgent_type === 1) {
                    guide += 'URGENT-STACK';
                } else if (this.scan.classification === 1) {
                    guide = 'Move box to NORMAL-STACK';
                } else if (this.scan.classification === 2) {
                    guide += 'MULTI-STACK';
                } else if (this.scan.classification === 3) {
                    guide += 'NO-DATA-STACK';
                } else if (this.scan.classification === 4) {
                    guide += 'SLOW-STACK';
                } else if (this.scan.classification === 5) {
                    guide += 'MULTI-TRACKING-STACK';
                } else if (this.scan.classification === 91) {
                    guide += 'RETURN-STACK';
                }

                return guide;
            },

            /**
             * 분류결과가 입고라벨 print가 가능한지 여부
             * @return bool
             **/
            printable() {
                if (! this.scan) {
                    return false;
                }

                return  this.scan.printable;
            },

            /**
             * 이미 예전에 스캔된 BOX인지 여부
             * @return bool
             **/
            isAlreadyShipIn() {
                if (! this.scan) {
                    return false;
                }

                return  this.scan.is_already_ship_in;
            },

            /**
             * 몇일전에 입고처리된건지 텍스트
             * @return string
             **/
            diffCreatedAt() {
                if (! this.scan) {
                    return false;
                }

                return  this.scan.diff_created_at;
            },

            /**
             * 스캔 input 클래스
             **/
            scanInputClass() {
                return {
                    'has-result': this.scan,
                };
            },

            /**
             * 결과부분 클래스
             **/
            resultClass() {
                return {
                    'has-warning': this.scan
                        && (this.scan.urgent_type === 1 || this.scan.classification === 2 || this.scan.classification === 3 || this.scan.classification === 5),
                    'slow-work': this.scan && this.scan.classification === 4,
                    'return': this.scan && this.scan.classification === 91,
                };
            },

        },

        mounted: function () {
            // 트래킹DB 갱신
            this.$refs['refresh'].refresh();
        },

        methods: {

            /**
             * 스캔 input 에 포커스를 줌
             */
            focus: function () {
                this.$refs.scan.focus();
            },

            /**
             * 스캔처리
             */
            scanning: function () {
                let scanned_no = this.$refs.scan.value;

                // 검증
                this.isEmptyScan = ! scanned_no;
                if (this.isEmptyScan) {
                    return;
                }

                /**
                 * 입력한 값으로 트래킹 조회
                 */
                    // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'post',
                        url: '/regions/' + this.regionId + '/ship-ins',
                        data: {
                            '_token': this.csrfToken,
                            'scanned_no': scanned_no,

                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.default(opts);
                });


                // promise 처리
                load.then((response) => {
                    // 조회
                    let ship_in = response.ship_in;

                    // 스캔결과 이벤트 발생
                    this.$emit('update:scan', ship_in);

                    // input 초기화
                    this.$refs.scan.value = null;

                    // 결과표시

                });



            },
        },
    }
</script>

<style lang="scss" scoped>
    .scan-input {
        .title {
            font-size: 2rem;
            .material-icons {
                font-size: 44px;
            }
        }



        input {
            font-size: 2rem;
            height: 80px;
            width: 80%;
            margin: 40px 0;
            text-align: center;
        }

        &.has-result {
            .title {
                font-size: 1.5rem;
                text-align: left;
                width: 80%;
                display: inline-block;

                .material-icons {
                    font-size: 30px;
                }
            }

            input {
                margin: 10px 0;
            }

            margin-bottom: 30px;
        }
    }

    .result {
        .center {
            width: 35%;
            font-size: 4rem;
            color: #666;
            padding: 2rem 5rem;
            margin-right: 3rem;
            border-bottom: 2rem solid #666;

            .material-icons {
                font-size: 5rem;
            }

            &.sea {
                color: #DE2D2E !important;
                border-bottom: 2rem solid #DE2D2E;
            }
        }
        .title {
            font-size: 3rem;
            color: #fff;
            background-color: #0f7ae5;
            padding: 50px;
        }
        .move-to {
            margin-top: 20px;
            font-size: 1.5rem;
        }
        .print {
            margin-top: 20px;
        }

        &.has-warning {
            .title {
                background-color: #ee395b;
            }
        }

        &.slow-work {
            .title {
                background-color: #FFA400;
            }
        }

        &.return {
            .title {
                background-color: #FFFF66;
                color: #000;
            }
        }
    }
</style>